import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../components/generalComponents/Table";
import {
	emptyBasket,
	fetchBasket,
	removeFromBasket,
} from "../../services/basket/actions";
import { loginAPI } from "../../services/login/actions";
import { calculateBasketTotal, formatPrice } from "../../utils/priceUtils";
import "./Basket.scss";

function Basket(props) {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		fetchBasket(props.currentLocation.id, props.userId);
	}, []);

	useEffect(() => {
		fetchBasket(props.currentLocation.id, props.userId);
	}, [props.currentLocation.id]);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleNo = () => {
		setOpen(false);
	};

	const handleYes = () => {
		setOpen(false);
		emptyBasket(props.currentLocation.id);
	};

	const determineDestination = () => {
		if (props.identifyInfo.public && !props.business) {
			return "/order_delivery_choice";
		} else {
			return "/scheduledelivery";
		}
	};

	const isBasketEmpty = () => {
		if (props.basketProducts?.length > 0) {
			return (
				<div>
					<div className="options">
						<Button
							style={{
								height: "50px",
								width: "150px",
								display: "inline-block",
								fontSize: "12px",
								marginRight: "5px",
								marginLeft: "5px",
								fontWeight: "bold",
							}}
							color="primary"
							variant="contained"
							onClick={handleClickOpen}
						>
							Winkelmandje leegmaken
						</Button>
						<Link to={determineDestination} style={{ textDecoration: "none" }}>
							<Button
								style={{
									height: "50px",
									width: "150px",
									display: "inline-block",
									fontSize: "12px",
									marginRight: "5px",
									marginLeft: "5px",
									fontWeight: "bold",
								}}
								color="primary"
								variant="contained"
							>
								Volgende stap
							</Button>
						</Link>
					</div>

					<Dialog
						open={open}
						onClose={handleNo}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">
							{"Weet u zeker dat u het winkelmandje leeg wilt maken?"}
						</DialogTitle>
						<DialogActions>
							<Button onClick={handleNo} color="primary">
								Nee
							</Button>
							<Button onClick={handleYes} color="primary" autoFocus>
								Ja
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			);
		}
	};

	const basketColumnsTable = [
		{ name: "Naam", dataName: "name" },
		{ name: "Prijs", dataName: "salesprice" },
		{ name: "Aantal", dataName: "number", component: "ProductAmountAcount" },
		{ name: "", dataName: "removeFromBasket", component: "removeFromBasket" },
	];

	return (
		<div>
			<h4 align="center">U bestelt voor: {props.currentLocation.name}</h4>
			<Table data={props.basketProducts} columnsMapping={basketColumnsTable} />
			<hr />
			<h3 align="center">
				{"Totale bedrag: " +
					formatPrice(calculateBasketTotal(props.basketProducts), "Euro")}
			</h3>
			{isBasketEmpty()}
		</div>
	);
}

const mapStateToProps = (state) => ({
	basketProducts: state.basket.products,
	userId: state.login.data.user_id,
	currentLocation: state.currentInformation.current_location,
	business: state.login.data.business,
	identifyInfo: state.identify.identifyInfo,
});

export default connect(mapStateToProps, {
	removeFromBasket,
	emptyBasket,
	fetchBasket,
	loginAPI,
})(Basket);
